import React from 'react'
import Navbar from '../../Components/Navbar'
import { useForm } from 'react-hook-form'
import { useParams, useNavigate } from 'react-router-dom'
import { useAuthContext } from '../../hooks'
import { createGoalCommentOfMemberAsProjectLead } from '../../api/ProjectLeadPerformance/createGoalCommentOfMemberAsProjectLead'
import { getMemberProjectGoal } from '../../api/ProjectLeadPerformance/getMemberProjectGoal'
import { getUserGoalByProject } from '../../api/UserPerformance/getuserGoalByProject'
import { useState, useEffect } from 'react'
import { TeamMemberSc } from './TeamMemberSc'
import Button from 'react-bootstrap/Button'
import ReactQuill from 'react-quill'
import parse from 'html-react-parser'
import { getPeopleLeadCommentByPlead } from '../../api/ProjectLeadPerformance/getPeopleLeadCommentByPlead'
function TeamMemberGoal() {
  const params = useParams()
  const navigate = useNavigate()
  const auth = useAuthContext()
  const [projectMemberGoal, setProjectMemberGoal] = useState<any>([])

  const fetchGoalOfOrgUser = async () => {
    if (!params?.viewProjectId) return
    setProjectMemberGoal(
      await getUserGoalByProject(
        auth?.userInfo?.orgs[0]?.id,
        params?.memberOrgUserID,
        params?.viewProjectId,
      ),
    )
    console.log('new works member Goal')
  }
  const [formValues, setFormValues] = useState({
    comment: '',
  })

  const handleTlComment = (value: any) => {
    setFormValues((prevState) => ({
      ...prevState,
      comment: value,
    }))
  }

  const handleSubmit = async (event: { preventDefault: () => void }) => {
    event.preventDefault()
    try {
      const response = await createGoalCommentOfMemberAsProjectLead(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString(),
        params?.viewProjectId,
        projectMemberGoal[0]?.goals[0]?.Id,
        { ...formValues },
      )
      console.log(response.data)
      alert('Comment addded successfully')
      getProjectLeadComment()
    } catch (error) {
      console.error(error)
    }
    navigate(`..`)
  }
  const handleCreateMemberGoalComment = async (e: any) => {
    console.log('data > ', e)
    await createGoalCommentOfMemberAsProjectLead(
      auth?.userInfo?.orgs[0]?.id,
      (auth?.userInfo?.orgs_user_id[0]).toString(),
      params?.viewProjectId,
      projectMemberGoal[0]?.goals[0]?.Id,
      { ...e },
    )
      .then((e) => {
        console.log(e)
      })
      .catch((err) => {
        console.log('====================================')
        console.log(err)
        console.log('====================================')
      })
  }

  console.log(' new Member Goal', projectMemberGoal[0]?.goals[0]?.Id)
  useEffect(() => {
    fetchGoalOfOrgUser()
  }, [])
  const [pleadComment, setPlEadCommment] = useState<any>()

  const getProjectLeadComment = async () => {
    const res = await getPeopleLeadCommentByPlead(
      auth?.userInfo?.orgs[0]?.id,
      params?.memberOrgUserID,
      params?.viewProjectId,
    )
    setPlEadCommment(res)
  }

  useEffect(() => {
    getProjectLeadComment()
  }, [])

  return (
    <TeamMemberSc>
      <div className="container">
        <div className="secondary-navbar">Team Member Goal</div>
        {projectMemberGoal &&
          projectMemberGoal?.map((data: any) => {
            return (
              <>
                <div className="heading">
                  <div className="headings">Member Name: {data?.name}</div>
                </div>
                <div className="goal-container">
                  {data &&
                    data?.goals?.map((goal: any) => {
                      return (
                        <>
                          <div className="goals-conatiner">
                            <div className="headings">
                              Project Name: {goal?.ProjectName}
                            </div>
                            <div className="headings">
                              Due date:{goal?.DueDate}
                            </div>
                          </div>

                          <div className="goal">Goal</div>

                          <div className="goal-content">
                            {parse(goal?.Goals)}
                          </div>
                        </>
                      )
                    })}
                </div>
              </>
            )
          })}
        <form className="project-lead-comment" onSubmit={handleSubmit}>
          <div>
            <label>Team Lead Comment</label>
          </div>

          {pleadComment?.[0]?.project_goals?.[0]?.Team_lead_comment !== null &&
          pleadComment?.[0]?.project_goals?.[0]?.Team_lead_comment.length >
            0 ? (
            <div>
              {parse(
                String(
                  pleadComment?.[0]?.project_goals?.[0]?.Team_lead_comment,
                ),
              )}
            </div>
          ) : (
            <>
              <div className="editor">
                <ReactQuill
                  className="editor"
                  value={formValues.comment}
                  onChange={handleTlComment}
                />
              </div>
              <div className="button">
                <Button type="submit" className="tl-button">
                  Submit
                </Button>
              </div>
            </>
          )}
        </form>
      </div>
    </TeamMemberSc>
  )
}

export default TeamMemberGoal
